/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-bloque-estudio-equip-docent block)");
/* eslint-enable no-console */


document.addEventListener("DOMContentLoaded", function(event) {
    activarDocentesControls();
});


function activarDocentesControls(){
    // $docentes = document.querySelectorAll('.list-docentes .open-close');
    $docentes = document.querySelectorAll('.list-docentes .docente .nombre');

    if($docentes.length>0){
        for (let $i = 0; $i < $docentes.length; $i++) {
            const $docenteCtrl = $docentes[$i];
            $docenteCtrl.addEventListener('click', function(){

                this.closest('.docente').classList.toggle('closed');
            })
            
        }
    }
}